/* @flow */

import * as React from 'react';
import { useSelector } from 'react-redux';

import type { KeyValuePair, Undefined } from '../../../helpers/jsHelpers/types';
import type { LocalesType } from '../../../redux/appConf/types/types';

import Localizer from '../../../helpers/localization';
import Modal from '../modal';
import './LegalNoticeModal.css';

const LegalNoticeModal = (): React.Node => {
  const locales = useSelector<LocalesType>((state) => state.appConfiguration.locales);
  const localesDefault = useSelector<KeyValuePair<Undefined<string>>>((state) => state.appConfiguration.localesDefault);

  const { legalInformation: defaultLegalInformation } = localesDefault;
  const localizedLegalInformation = Localizer.getLocalizedStringFromAppConf(locales, 'legalInformation', defaultLegalInformation);

  return (
    <Modal ariaLabel={Localizer.localize('accessibility.modal.legal_notice')} className='legalNotice'>
      <div className='header'>{Localizer.localize('modal.legal_information.title')}</div>
      <div className='legalContent'>{localizedLegalInformation}</div>
    </Modal>
  );
};

export default LegalNoticeModal;
